import { render, staticRenderFns } from "./ParentElement.vue?vue&type=template&id=195c1280"
import script from "./ParentElement.vue?vue&type=script&lang=js"
export * from "./ParentElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports